import { Modal } from 'antd';
import { DeleteFilled, ReloadOutlined } from '@ant-design/icons';
import { 
  BrandedModalProps, 
  HighSafetyBrandedModalProps, 
  DeleteModalProps, 
  ResetModalProps
} from './types';
import {
  ENFORCED_BUTTON_TYPES,
  ENFORCED_MODAL_TEXT_YES,
  ENFORCED_MODAL_TEXT_NO
} from './constants';

const { confirm } = Modal;

/**
 * Generic confirmation modal (strict - requires okType)
 */
const showCommonConfirmModal = (props: BrandedModalProps) => {
  confirm({
    ...props,
    centered: true,
    width: 416,
    styles: { 
      mask: { backdropFilter: 'blur(4px)' } 
    },
  });
};

/**
 * Base for high-risk modals that require strict safety behavior.
 */
const showHighSafetyDangerConfirmModal = (props: HighSafetyBrandedModalProps) => {
  showCommonConfirmModal({
    ...props,
    maskClosable: false,
    autoFocusButton: 'cancel',
    okButtonProps: { danger: true },
  });
};

/**
 * Standardized Delete confirmation.
 */
export const showDeleteConfirmModal = (props: DeleteModalProps) => {
  showHighSafetyDangerConfirmModal({
    ...props,
    okText: ENFORCED_MODAL_TEXT_YES.DELETE,
    cancelText: ENFORCED_MODAL_TEXT_NO.CANCEL,
    icon: <DeleteFilled style={{ color: '#ff4d4f' }} />,
    okType: ENFORCED_BUTTON_TYPES.DANGER, 
  });
};

/**
 * Standardized Reset confirmation.
 */
export const showResetConfirmModal = (props: ResetModalProps) => {
  showHighSafetyDangerConfirmModal({
    ...props,
    okText: ENFORCED_MODAL_TEXT_YES.RESET,
    cancelText: ENFORCED_MODAL_TEXT_NO.CANCEL,
    icon: <ReloadOutlined style={{ color: '#1677ff' }} />,
    okType: ENFORCED_BUTTON_TYPES.PRIMARY, 
  });
};
